import { NgClass } from '@angular/common';
import {
    // ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
    input,
} from '@angular/core';

import {
    DeviceService,
    DynamicHtmlDirective,
    LoadingIndicatorHandler,
    LoadingIndicatorService,
    // MessageLifetime,
    // MessageQueueService,
    NavigationService,
    TrackingService,
} from '@frontend/vanilla/core';
// import { MessagePanelComponent } from '@frontend/vanilla/features/message-panel';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';

import { UploadConfig } from '../client-config/client-config.models';
import { FilePickService } from '../common/file-pick.service';
import { ImagePickDirective } from '../directives/image-pick.directive';
import { PortalTrackingService } from '../tracking/tracking-resource.service';
import { TrackingEvent } from '../tracking/tracking.model';
import { DocDetailsRequestModel, DocStatusType, DocumentSelected, FileData } from './upload.models';

@Component({
    selector: 'pt-upload-file',
    templateUrl: 'upload-file.component.html',
    providers: [FilePickService],
    styleUrls: ['../../styles/portal/multi-doc-upload.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        NgClass,
        DynamicHtmlDirective,
        TrustAsHtmlPipe,
        ImagePickDirective,
        //  MessagePanelComponent
    ],
})
export class UploadFileComponent implements OnInit, OnDestroy {
    @ViewChild('fileInput') fileInput: ElementRef;
    @Input() label: string;
    @Input() content: any;
    @Input() isMultiDocUpload: boolean = false;
    @Input() allowUpload: boolean = true;
    @Input() greeceComplaintEnabled: boolean = false;
    @Input() showChooseFileLink: boolean = true;
    @Input() showNegativeClass: boolean = false;
    @Output() documentSelected: EventEmitter<DocumentSelected> = new EventEmitter();
    @Output() throwParentErrors: EventEmitter<boolean> = new EventEmitter();
    @Output() documentUploadError: EventEmitter<{ ErrorMessage: string }> = new EventEmitter();
    @Output() progressfilled: EventEmitter<boolean> = new EventEmitter();
    @Input() twoStepUploadEnabled: boolean = false;
    @Input() doclist: DocDetailsRequestModel[] = [];
    @Input() multidocUploadv2: boolean;
    @Input() showUploadInfo: boolean;
    @Input() source: string;
    @Input() enableDragAndDrop: boolean = true;
    @Input() enableUploadpaymentCard: boolean = false;
    @Input() acqEnhancements: any;
    @Input() enableCardInfo: any;
    fromPersonalDetails = input<boolean>(false);

    imageData: any = {};
    isError: boolean = false;
    waitRemind: boolean = false;
    hasAddedDocument: boolean = false;
    errorMessage: string | null = null;
    isTouch: boolean;
    ACCEPT_TYPES: string;
    isOtherFilesAllowed: boolean;
    fileUploadText: string;
    filesList: any[] = [];
    darkModeEnabled: boolean = false;
    totalFilesSize: number = 0;
    url: string;
    action: any;
    isShowProgressBar: boolean = false;
    progressWidth: number = 0;
    wait = false;
    showFailedProgressbar: boolean = false;
    progressValue: number = 10;
    startLoadingBar: any;
    checkStatusInterval: any;
    timeToCheckStatus: number = 5000;
    progressbar: any;
    step2: boolean = false;
    currentfileList: boolean = false;
    private loadingIndicatorHandler: LoadingIndicatorHandler;
    timeToCheckUpload: number = 1000; //to check files are in progress
    checkLoadingBar: any;
    checkIntervalRunning: boolean = false;
    TotalFileSizeExceeded: boolean = false;
    isMobile: any;
    isDuplicateFile: boolean = false;
    newDocUploadInterceptor: boolean = false;
    docCollectionFlow: boolean = false;

    // private readonly messageQueueService = inject(MessageQueueService);

    constructor(
        private loadingIndicator: LoadingIndicatorService,
        private uploadConfig: UploadConfig,
        private filePickService: FilePickService,
        private tracking: TrackingService,
        private deviceService: DeviceService,
        private darkModeService: DarkModeService,
        public device: DeviceService,
        private navigation: NavigationService,
        private portalTrackingService: PortalTrackingService,
        // private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.isMobile = this.device.isMobile;
        this.isTouch = this.deviceService.isTouch;
        this.isOtherFilesAllowed = this.uploadConfig.allowedFileTypes.indexOf('application/pdf') > -1;
        this.darkModeEnabled = this.darkModeService.isEnabled ? true : false;
        if (this.isOtherFilesAllowed) {
            const fileText = this.content.messages.MobileDragDropOtherSectionText;
            this.fileUploadText = fileText.replace('{0}', this.content.messages.FileTypeOther);
        } else {
            this.fileUploadText = this.content.messages['MobileDragDropSectionText'];
        }
        this.ACCEPT_TYPES = this.uploadConfig.allowedFileTypes;
        this.filePickService.imageData.subscribe((data) => {
            this.imageLoaded(data);
        });
        this.filePickService.imageName.subscribe((data) => {
            this.imagePicked(data);
        });
        this.filePickService.imageError.subscribe((data) => {
            this.imageError(data);
        });
        if (this.navigation.location.search?.has('doccollectionflow') && this.navigation.location.search?.get('doccollectionflow') == 'true') {
            this.docCollectionFlow = true;
        }
        this.eventTracking(
            'document upload',
            'manual doc upload',
            'load',
            'step 2',
            'upload the document',
            'upload the document',
            'Event.DocumentUpload',
            this.docCollectionFlow ? 'missing doc collection' : 'expired kyc',
        );
        const trackingParams = {
            'component.CategoryEvent': 'kyc',
            'component.LabelEvent': 'pre jumio',
            'component.ActionEvent': 'load',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'manual uploading identity documents - verify id screen',
            'component.EventDetails': 'manual uploading identity documents - verify id screen',
            'component.URLClicked': 'not applicable',
        };
        if (this.docCollectionFlow) {
            let docCollection = {
                ...trackingParams,
                'component.flowName': 'missing doc collection',
            };
            this.tracking.triggerEvent('contentView', docCollection);
        }
        if (this.source != 'rib_de' && !(this.navigation.location.search.get('trigger') == 'docexpiry') && !this.docCollectionFlow) {
            this.tracking.triggerEvent('contentView', trackingParams);
        }
    }
    eventTracking(
        categoryEvent: string,
        labelEvent: string,
        actionEvent: string,
        positionEvent: string,
        locationEvent: string,
        eventdetails: string,
        eventName: string,
        flowName?: string,
    ) {
        const trackingevents: TrackingEvent = {
            CategoryEvent: categoryEvent,
            LabelEvent: labelEvent,
            ActionEvent: actionEvent,
            PositionEvent: positionEvent,
            LocationEvent: locationEvent,
            EventDetails: eventdetails,
            UrlClicked: 'not applicable',
        };
        if (this.navigation.location.search.get('trigger') == 'docexpiry' || this.docCollectionFlow) trackingevents.flowName = flowName;
        this.portalTrackingService.trackEvents(trackingevents, '', eventName);
    }
    steponeSelected() {
        this.step2 = true;
        this.imageData = {};
        this.isShowProgressBar = false;
        return this.step2;
    }

    ngOnDestroy(): void {
        if (this.filePickService) {
            if (this.filePickService.imageName) {
                this.filePickService.imageName.unsubscribe();
            }
            if (this.filePickService.imageData) {
                this.filePickService.imageData.unsubscribe();
            }
            if (this.filePickService.imageError) {
                this.filePickService.imageError.unsubscribe();
            }
        }
    }

    chooseFile() {
        this.fileInput.nativeElement.value = null; //fix for event not firing upon selecting the same file
        const event = new MouseEvent('click', { bubbles: true });
        this.fileInput.nativeElement.dispatchEvent(event);
        this.eventTracking(
            'document upload',
            'manual doc upload',
            'click',
            'step 2',
            'upload the document',
            'tap to upload document',
            'Event.DocumentUpload',
            this.docCollectionFlow ? 'missing doc collection' : 'expired kyc',
        );
        const trackingParams = {
            'component.CategoryEvent': 'kyc',
            'component.LabelEvent': 'pre jumio',
            'component.ActionEvent': 'click',
            'component.PositionEvent': !this.step2 ? 'step1' : 'step2',
            'component.LocationEvent': 'manual uploading identity documents - verify id screen',
            'component.EventDetails': 'tap to upload document',
            'component.URLClicked': 'not applicable',
        };
        if (this.source != 'rib_de' && !(this.navigation.location.search.get('trigger') == 'docexpiry') && !this.docCollectionFlow) {
            this.tracking.triggerEvent('Event.KYC', trackingParams);
        } else if (this.docCollectionFlow) {
            let docCollection = {
                ...trackingParams,
                'component.flowName': 'missing doc collection',
            };
            this.tracking.triggerEvent('Event.KYC', docCollection);
        }
    }

    clearThisFile(selectedFile: FileData) {
        const index = this.filesList.findIndex((x) => x.Name === selectedFile.Name && x.Data == selectedFile.Data);
        const file: any = this.filesList[index];
        if (file) this.totalFilesSize -= file.fileSize;
        this.filesList.splice(index, 1);
        this.hasAddedDocument = false;
        this.validateAllFiles();
        this.documentSelected.emit({ status: DocStatusType.docCleared, data: { selectedFile: selectedFile, updatedFiles: this.filesList } });
    }

    clearFile() {
        this.currentfileList = false;
        this.imageData = {};
        this.hasAddedDocument = false;
        this.progressValue = 10;
        this.progressWidth = 10;
        this.isShowProgressBar = false;
        this.checkStatusAndReload();
        this.progressfilled.emit(false);
        this.documentSelected.emit({ status: DocStatusType.docCleared, data: null });
        const trackingParams = {
            'component.CategoryEvent': 'kyc',
            'component.LabelEvent': 'pre jumio',
            'component.ActionEvent': 'click',
            'component.PositionEvent': !this.step2 ? 'step1' : 'step2',
            'component.LocationEvent': 'manual uploading identity documents - verify id screen',
            'component.EventDetails': 'remove',
            'component.URLClicked': 'not applicable',
        };
        if (this.docCollectionFlow) {
            let docCollection = {
                ...trackingParams,
                'component.flowName': 'missing doc collection',
            };
            this.tracking.triggerEvent('Event.KYC', docCollection);
        } else this.tracking.triggerEvent('Event.KYC', trackingParams);
    }

    imagePicked(data: any) {
        if (!this.allowUpload) return;
        if (!data) {
            return;
        }
        if (data.fileName) {
            this.waitRemind = true;
            this.imageData.Name = data.fileName;
            this.loadingIndicatorHandler = this.loadingIndicator.start();
            if (!this.isMultiDocUpload) this.documentSelected.emit({ status: DocStatusType.docPicked, data: null });
            if ((this.twoStepUploadEnabled || !this.isShowProgressBar) && !this.multidocUploadv2) {
                this.progressbarview();
            }
            if (this.twoStepUploadEnabled) this.documentSelected.emit({ status: DocStatusType.docPicked, data: data });
            if (!this.isMultiDocUpload && !this.twoStepUploadEnabled) this.documentSelected.emit({ status: DocStatusType.docPicked, data: data });
        }
    }

    imageLoaded(imageData: any) {
        if (!imageData) {
            return;
        }
        this.imageData.ContentType = imageData.mimeType;
        this.isError = false;
        this.errorMessage = null;
        this.imageData.Data = imageData.data;
        this.imageData.fileSize = imageData.fileSize;
        this.hasAddedDocument = true;
        this.imageData.UploadDocumentNotSupported = false;
        this.imageData.maxSize = false;
        if (!this.isMultiDocUpload && !this.twoStepUploadEnabled && !this.multidocUploadv2) {
            if (this.imageData.fileSize > this.uploadConfig.maxUserFileSizeInKb * 1024)
                this.documentSelected.emit({ status: DocStatusType.docSizeError, data: null });
            else this.documentSelected.emit({ status: DocStatusType.docLoaded, data: this.imageData });
        } else if (!this.isMultiDocUpload && this.twoStepUploadEnabled && !this.multidocUploadv2) {
            this.imageData.fileSizeInText = this.formatBytes(imageData.fileSize, 2);
            this.imageData.UploadedSuccessfully = true;
            this.imageData.TotalFileSizeExceeded = false;
            this.totalFilesSize += this.imageData.fileSize;
            if (this.imageData.fileSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) this.imageData.UploadedSuccessfully = false;
            if (this.totalFilesSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) this.imageData.TotalFileSizeExceeded = true;
            if (this.filesList.find((file: FileData) => file.Name === this.imageData.Name || (this.currentfileList && this.doclist.length != 2))) {
                this.filesList = [];
                this.currentfileList = false;
            }
            if (
                this.filesList.findIndex((file: FileData) => file.Name === this.imageData.Name) == -1 &&
                this.filePickService.isValidSize(imageData.fileSize, this.twoStepUploadEnabled)
            ) {
                this.filesList.push(Object.assign({}, this.imageData));
                this.currentfileList = true;
                this.documentSelected.emit({ status: DocStatusType.docLoaded, data: this.imageData });
            }
            this.tracking.triggerEvent('Event.KYC', {
                'component.CategoryEvent': 'kyc',
                'component.LabelEvent': 'pre jumio',
                'component.ActionEvent': 'click',
                'component.PositionEvent': !this.step2 ? 'step1' : 'step2',
                'component.LocationEvent': 'manual uploading identity documents - verify id screen',
                'component.EventDetails': 'successfully uploaded ',
                'component.URLClicked': 'not applicable',
            });
        } else if (this.multidocUploadv2) {
            this.imageData.fileSizeInText = this.formatBytes(imageData.fileSize, 2);
            this.imageData.UploadedSuccessfully = true;
            this.imageData.TotalFileSizeExceeded = false;
            this.totalFilesSize += this.imageData.fileSize;
            if (this.imageData.fileSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) this.imageData.UploadedSuccessfully = false;
            if (
                this.totalFilesSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024 ||
                this.imageData.fileSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024
            )
                this.imageData.TotalFileSizeExceeded = true;
            if (this.filesList.findIndex((file: FileData) => file.Name === this.imageData.Name) == -1) {
                this.isDuplicateFile = false;
                this.handleMultiDocUpload();

                this.documentSelected.emit({ status: DocStatusType.docLoaded, data: this.imageData });
            } else {
                this.isDuplicateFile = true;
                this.handleMultiDocUploadError();
                return;
            }
        } else {
            this.imageData.fileSizeInText = this.formatBytes(imageData.fileSize, 2);
            this.imageData.UploadedSuccessfully = true;
            this.imageData.TotalFileSizeExceeded = false;
            this.totalFilesSize += this.imageData.fileSize;
            if (this.imageData.fileSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) this.imageData.UploadedSuccessfully = false;
            if (this.totalFilesSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) this.imageData.TotalFileSizeExceeded = true;
            if (
                this.filesList.findIndex((file: FileData) => file.Name === this.imageData.Name) == -1 &&
                this.filePickService.isValidSize(imageData.fileSize, this.isMultiDocUpload)
            ) {
                this.filesList.push(Object.assign({}, this.imageData));
                this.documentSelected.emit({ status: DocStatusType.docLoaded, data: this.imageData });
            } else {
                this.handleMultiDocUploadError();
                return;
            }
        }
        this.finishImageLoading();
    }

    imageError(data: any) {
        if (!data) {
            return;
        }
        // this.messageQueueService.clear();
        this.isError = true;
        this.waitRemind = false;
        this.errorMessage = null;
        const fileReaderError = data.error;
        if (fileReaderError) {
            this.tracking.updateDataLayer({ 'page.name': 'Document Upload Error File not Found', 'page.siteSection': 'Kyc' });
            this.tracking.reportError({ message: 'Document Upload Error File not Found', code: '' });
        }

        const buttonLabel = this.hasAddedDocument ? this.content.form.buttonchangepicture.label : this.content.form.buttonchoosepicture.label;
        let message = '';
        if (this.isOtherFilesAllowed) {
            this.errorMessage = this.content.messages.UploadOtherDocumentNotSupported;
            // if (this.fromPersonalDetails()) this.messageQueueService.addError(this.errorMessage || '', MessageLifetime.Single, 'showError');
        } else {
            message = fileReaderError ? this.content.messages.UploadDocumentNotReadable : this.content.messages.UploadDocumentNotSupported;
            this.errorMessage = message.replace('{0}', buttonLabel);
            // if (this.fromPersonalDetails()) this.messageQueueService.addError(this.errorMessage || '', MessageLifetime.Single, 'showError');
        }
        // if (this.fromPersonalDetails()) this.cdr.detectChanges();
        if (this.loadingIndicatorHandler) {
            this.loadingIndicatorHandler.done();
        }
        if (data.maxSize) {
            this.documentSelected.emit({ status: DocStatusType.docSizeError, data: null });
        } else {
            this.documentSelected.emit({ status: DocStatusType.docError, data: null });
        }

        if (this.greeceComplaintEnabled) {
            this.tracking.triggerEvent('Event.Tracking', {
                'component.CategoryEvent': 'Help Center',
                'component.LabelEvent': 'Help options',
                'component.ActionEvent': 'Load',
                'component.PositionEvent': 'Official Complaint Form',
                'component.LocationEvent': 'Error Message',
                'component.EventDetails': this.errorMessage,
                'component.URLClicked': 'not applicable',
            });
        }
        const trackingParams = {
            'component.CategoryEvent': 'kyc',
            'component.LabelEvent': 'pre jumio',
            'component.ActionEvent': 'click',
            'component.PositionEvent': !this.step2 ? 'step1' : 'step2',
            'component.LocationEvent': 'manual uploading identity documents - verify id screen',
            'component.EventDetails': 'failed',
            'component.URLClicked': 'not applicable',
        };
        if (this.docCollectionFlow) {
            let docCollection = {
                ...trackingParams,
                'component.flowName': 'missing doc collection',
            };
            this.tracking.triggerEvent('Event.KYC', docCollection);
        } else this.tracking.triggerEvent('Event.KYC', trackingParams);
        if (this.errorMessage) this.documentUploadError.emit({ ErrorMessage: this.errorMessage });
    }

    drop(e: any) {
        e.preventDefault();
        this.filePickService.pictureChanged(e.dataTransfer.files, this.isMultiDocUpload);
    }

    allowDrop(ev: any) {
        ev.preventDefault();
    }
    allowFileUpload(event: any) {
        if (!this.allowUpload) {
            this.isError = true;
            this.waitRemind = false;
            this.throwParentErrors.emit(true);
            if (this.loadingIndicatorHandler) {
                this.loadingIndicatorHandler.done();
            }
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        return;
    }

    private finishImageLoading() {
        this.waitRemind = false;
        this.isError = false;
        if (this.loadingIndicatorHandler) {
            this.loadingIndicatorHandler.done();
        }
    }

    private handleMultiDocUploadError() {
        this.isError = true;
        if (this.multidocUploadv2) {
            this.validateAllFilesV2();
            this.totalFilesSize -= this.imageData.fileSize;
        }
        this.errorMessage = this.content.messages.SameFilePicked;
        this.waitRemind = false;
        if (this.loadingIndicatorHandler) {
            this.loadingIndicatorHandler.done();
        }
        this.documentSelected.emit({ status: DocStatusType.docError, data: null });
    }
    handlePlDocUploadError() {
        this.isError = true;
        this.errorMessage = this.content.messages.SameFilePicked;
        this.waitRemind = false;
        if (this.loadingIndicatorHandler) {
            this.loadingIndicatorHandler.done();
        }
        this.documentSelected.emit({ status: DocStatusType.docError, data: null });
    }

    private formatBytes(bytes: number, decimals: number = 0) {
        if (bytes == 0) return '0 Bytes';
        const k = 1024,
            dm = decimals <= 0 ? 0 : decimals || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
    }
    private validateAllFiles() {
        this.isError = false;
        let recalculateFileSizes: number = 0;
        this.filesList.map((file: any) => {
            recalculateFileSizes += file.fileSize;
            file.UploadedSuccessfully = true;
            file.TotalFileSizeExceeded = false;
            if (file.fileSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) file.UploadedSuccessfully = false;
            if (recalculateFileSizes > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) file.TotalFileSizeExceeded = true;
        });
    }
    progressbarview() {
        if (this.imageData) {
            this.progressValue = 0;
            this.isShowProgressBar = true;
            this.progressWidth = 0;
            this.loadProgressbar();
            this.wait = true;
            if (this.showFailedProgressbar) this.showFailedProgressbar = false;
        }
    }

    fillBar(value: number): void {
        if (value <= 90) {
            this.progressValue += 10.0;

            this.progressfilled.emit(false);
        }

        const progressClass = document.getElementById('progressValueV2');
        if (progressClass) progressClass.innerHTML = this.progressValue.toFixed(0) + '%';
        this.progressWidth = parseInt(this.progressValue.toFixed(0));
        if (value >= 100 && !this.isError) {
            clearInterval(this.startLoadingBar);
            this.progressfilled.emit(true);
        }
    }
    loadProgressbar() {
        const time: number = 1500;
        this.fillBar(this.progressWidth);
        this.startLoadingBar = setInterval(() => {
            this.fillBar(this.progressValue);
        }, time);
        this.checkStatusInterval = setInterval(() => {
            this.checkStatusAndReload();
        }, this.timeToCheckStatus);
        return this.startLoadingBar;
    }
    checkStatusAndReload(): void {
        clearInterval(this.checkStatusInterval);
        this.progressfilled.emit(false);
    }
    checkUploadStatus() {
        if (this.filesList.length == 0) return;

        const enableUpload = this.filesList.every((item) => item.progressValue == 100 && !item.isError);

        if (enableUpload) {
            this.checkIntervalRunning = false;
            clearInterval(this.checkLoadingBar);
            this.progressfilled.emit(true);
        } else {
            this.checkIntervalRunning = true;
            this.progressfilled.emit(false);
        }
    }
    fillBarV2(item: any): void {
        if (item.progressValue <= 90) {
            item.progressValue += 10.0;
            item.fileUploadisInProgress = false;
        }

        const progressClass = document.getElementById(item.fileName);
        if (progressClass) progressClass.innerHTML = item.progressValue.toFixed(0) + '%';
        item.progressWidth = parseInt(item.progressValue.toFixed(0));
        if (item.progressValue >= 100 && !this.isError) {
            clearInterval(item.startLoadingBar);
        }
    }
    loadProgressbarV2(item: any) {
        const time: number = 1500;
        this.fillBarV2(item);
        item.startLoadingBar = setInterval(() => {
            this.fillBarV2(item);
        }, time);
        return item.startLoadingBar;
    }
    progressbarviewV2(data: any) {
        if (data) {
            this.filesList.map((item) => {
                if (item.Name === data.Name) {
                    item.progressValue = 0;
                    item.isError = false;
                    item.isShowProgressBar = true;
                    item.progressWidth = 0;
                    item.showFailedProgressbar = false;
                    item.ContentType = data.ContentType;
                    item.TotalFileSizeExceeded = data.TotalFileSizeExceeded ? true : false;
                    this.loadProgressbarV2(item);
                    if (item.showFailedProgressbar) item.showFailedProgressbar = false;
                }
            });
        }
    }
    clearFileV2(selectedFile: FileData, actionType?: string) {
        this.isDuplicateFile = false;
        const index = this.filesList.findIndex((x) => x.Name === selectedFile.Name && x.Data == selectedFile.Data);
        const file: any = this.filesList[index];
        if (file) this.totalFilesSize -= file.fileSize;
        this.filesList.splice(index, 1);
        this.hasAddedDocument = false;
        this.validateAllFilesV2();
        this.documentSelected.emit({
            status: DocStatusType.docCleared,
            data: { selectedFile: selectedFile, updatedFiles: this.filesList },
            action: actionType,
        });
    }
    private validateAllFilesV2() {
        this.TotalFileSizeExceeded = false;
        let recalculateFileSizes: number = 0;
        this.filesList.map((file: any) => {
            recalculateFileSizes += file.fileSize;
            file.UploadedSuccessfully = true;
            file.TotalFileSizeExceeded = false;
            file.isError = false;
            file.errorMessage = null;
            if (file.fileSize > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) file.UploadedSuccessfully = false;
            if (recalculateFileSizes > this.uploadConfig.multiDocMaxUserFileSizeInKb * 1024) file.TotalFileSizeExceeded = true;
            if (!this.filePickService.isValidSize(file.fileSize, false)) {
                this.imageData.TotalFileSizeExceeded = true;
                file.TotalFileSizeExceeded = true;
                file.isError = true;
                file.errorMessage = this.content.messages.NotSuccessfullyUploaded;
            } else if (!this.filePickService.isValidSize(recalculateFileSizes, false)) {
                this.imageData.TotalFileSizeExceeded = true;
                file.isError = true;
                file.TotalFileSizeExceeded = true;
                file.errorMessage = this.content.messages.TotalFileSizeLimitExceeded;
            }
            if (!this.isValidFileType(file.ContentType)) {
                this.imageData.UploadedSuccessfully = false;
                file.isError = true;
                file.errorMessage = this.content.messages.UploadDocumentNotSupported;
            }
        });
        this.TotalFileSizeExceeded = this.filesList.find((file) => file.TotalFileSizeExceeded);
        this.allowUpload = !this.filesList.find((file) => file.isError);
    }
    handleMultiDocUpload() {
        this.filesList.push(Object.assign({}, this.imageData));
        this.progressbarviewV2(this.imageData);
        this.validateAllFilesV2();
        if (!this.checkIntervalRunning) {
            this.checkLoadingBar = setInterval(() => {
                this.checkUploadStatus();
            }, this.timeToCheckUpload);
        }
    }
    private isValidFileType(type: any) {
        return type.length && type.length > 0 && this.uploadConfig.allowedFileTypes.indexOf(type) > -1;
    }
}
